var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8929 4.49698L11.1071 3.88959V11.1103L13.8929 10.5029V4.49698ZM15.75 10.0981L18.266 9.54957C18.4737 9.50428 18.66 9.38786 18.7935 9.21974C18.9271 9.05162 19 8.84197 19 8.62578V6.37422C19 6.15803 18.9271 5.94838 18.7935 5.78026C18.66 5.61214 18.4737 5.49572 18.266 5.45043L15.75 4.9019V10.0981ZM6 3.94486V11.0551C5.99999 11.1961 6.03096 11.3352 6.09064 11.4624C6.15033 11.5895 6.23721 11.7015 6.34494 11.7901C6.45266 11.8786 6.5785 11.9416 6.71322 11.9742C6.84795 12.0069 6.98816 12.0085 7.12357 11.9789L9.25 11.5152V3.48476L7.12357 3.02107C6.98816 2.99147 6.84795 2.99308 6.71322 3.02576C6.5785 3.05844 6.45266 3.12137 6.34494 3.20994C6.23721 3.29851 6.15033 3.41048 6.09064 3.53764C6.03096 3.6648 5.99999 3.80394 6 3.94486Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3V17.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWind);
export default __webpack_public_path__ + "static/media/icon_wind.68f19db23e29cedabec8a808f317ef46.svg";
export { ForwardRef as ReactComponent };